import React from 'react';
import { Form } from 'semantic-ui-react';

import * as rutUtils from './rut';

interface PagoTransferenciaProps {
    tipoDeCuenta: '' | 'corriente' | 'vista' | 'chequera';
    idInstitucionTransferencia: string;
    numeroDeCuentaTransferencia: string;
    nombreDelTitularTransferencia: string;
    esDeTercerosTransferencia: boolean;
    rutTitularTransferencia: string;

    alCambiarCampo(nombreDelCampo: string, valor: string | boolean): void;
}
// TODO: instituciones agregadas a mano. Hay que sacarlas del mismo lado de matriculas

const PagoTransferencia: React.FunctionComponent<PagoTransferenciaProps> = props => {
    const {
        tipoDeCuenta,
        idInstitucionTransferencia,
        numeroDeCuentaTransferencia,
        nombreDelTitularTransferencia,
        esDeTercerosTransferencia,
        rutTitularTransferencia,
        alCambiarCampo,
    } = props;

    return (
        <div>
            <Form.Select
                label='Tipo de cuenta'
                placeholder='Seleccione'
                value={tipoDeCuenta}
                width={6}
                options={[
                    { value: '', text: 'No especificada' },
                    { value: 'corriente', text: 'Cuenta corriente' },
                    { value: 'vista', text: 'cuenta vista' },
                    { value: 'chequera', text: 'Chequera electrónica' },
                ]}
                onChange={(_e, { value }) => {
                    alCambiarCampo('tipoDeCuenta', value as string);
                }}
            />
            <Form.Select
                label='Institución'
                placeholder='Seleccione'
                value={idInstitucionTransferencia}
                width={6}
                options={[
                    { value: '', text: 'No especificada' },
                    { value: 'bbva', text: 'BANCO BBVA' },
                    { value: 'bci', text: 'BANCO BCI-TBANK-NOVA' },
                    { value: 'bice', text: 'BANCO BICE' },
                    { value: 'btg', text: 'BANCO BTG PACTUAL CHILE' },
                    { value: 'consorcio', text: 'BANCO CONSORCIO' },
                    { value: 'corpbanca', text: 'BANCO CORPBANCA' },
                    { value: 'edwards', text: 'BANCO DE CHILE/EDWARDS CITYBANK' },
                    { value: 'estado', text: 'BANCO ESTADO' },
                    { value: 'falabella', text: 'BANCO FALABELLA' },
                    { value: 'hsbc', text: 'BANCO HSBC BANK CHILE' },
                    { value: 'itau', text: 'BANCO ITAU' },
                    { value: 'internacional', text: 'BANCO INTERNACIONAL' },
                    { value: 'paris', text: 'BANCO PARIS' },
                    { value: 'penta', text: 'BANCO PENTA' },
                    { value: 'rabobank', text: 'BANCO RABOBANK CHILE (EX HNS BANCO)' },
                    { value: 'ripley', text: 'BANCO RIPLEY' },
                    { value: 'santander', text: 'BANCO SANTANDER BANEFE' },
                    { value: 'scotiabank', text: 'BANCO SCOTIABANK/DESARROLLO' },
                    { value: 'security', text: 'BANCO SECURITY' },
                ]}
                onChange={(_e, { value }) => {
                    alCambiarCampo('idInstitucionTransferencia', value as string);
                }}
            />
            <Form.Input
                label='Nº de cuenta'
                placeholder='00000000000'
                value={numeroDeCuentaTransferencia}
                width={6}
                onChange={(_e, { value }) => {
                    alCambiarCampo('numeroDeCuentaTransferencia', value);
                }}
            />
            <Form.Input
                label='Nombre del titular'
                placeholder='Mario Cabezas Parra'
                value={nombreDelTitularTransferencia}
                width={6}
                onChange={(_e, { value }) => {
                    alCambiarCampo('nombreDelTitularTransferencia', value);
                }}
            />
            <Form.Input
                label='Rut del titular'
                placeholder='12.345.678-9'
                value={rutTitularTransferencia}
                width={6}
                onChange={(_e, { value }) => {
                    alCambiarCampo('rutTitularTransferencia', rutUtils.formatear(value));
                }}
            />
            <Form.Checkbox
                label='Es de terceros'
                checked={esDeTercerosTransferencia}
                onChange={(_e, { checked }) => {
                    alCambiarCampo('esDeTercerosTransferencia', checked!);
                }}
            />
        </div>
    );
};

export default PagoTransferencia;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/PagoTransferencia.tsx